import clsx from 'clsx'
import { HeadMetatags } from 'routes/components/HeadMetatags'
import { Hgroup } from 'routes/components/Hgroup'
import { InnerPageLayout } from 'routes/layouts'

import { ResponsiveImg } from '../components/ResponsiveImage'
import classes from './hiw.module.css'

import { LINKS } from 'routes/constants'
import Hiw_1 from './assets/hiw-1.png'
import Hiw_1_Mobile from './assets/hiw-1_mobile.png'
import Hiw_2 from './assets/hiw-2.png'
import Hiw_2_Mobile from './assets/hiw-2_mobile.png'
import Hiw_3 from './assets/hiw-3.png'
import Hiw_3_Mobile from './assets/hiw-3_mobile.png'
import Hiw_4 from './assets/hiw-4.png'
import Hiw_4_Mobile from './assets/hiw-4_mobile.png'
import Hiw_5_1 from './assets/hiw-5_1.png'
import Hiw_5_1_Mobile from './assets/hiw-5_1_mobile.png'
import Hiw_5_2 from './assets/hiw-5_2.png'
import Hiw_5_2_Mobile from './assets/hiw-5_2_mobile.png'
import Hiw_6_1 from './assets/hiw-6_1.png'
import Hiw_6_1_Mobile from './assets/hiw-6_1_mobile.png'
import Hiw_6_2 from './assets/hiw-6_2.png'
import Hiw_6_2_Mobile from './assets/hiw-6_2_mobile.png'

export default function PricingPage() {
  return (
    <InnerPageLayout className={classes.wrapper}>
      <HeadMetatags title='How it Works' />
      <h1 className={classes.header}>How it Works</h1>

      <Hgroup className={classes.hgroup}>
        <h2>1. Select apps to integrate with</h2>
        <p>
          Select any number of apps from our{' '}
          <a href={LINKS.CONNECTORS} target='_blank'>
            ever-growing catalog
          </a>{' '}
          or use our connector builder tool to add custom integrations.
        </p>
      </Hgroup>

      <div className={classes.block_1}>
        <ResponsiveImg img={Hiw_1} imgMobile={Hiw_1_Mobile} />
      </div>

      <Hgroup className={classes.hgroup}>
        <h2>2. Let your customers connect their accounts in external apps</h2>
        <p>
          Use our drop-in UI or{' '}
          <a
            href='https://console.integration.app/docs/ui/connection/custom'
            target='_blank'
          >
            build your own
          </a>{' '}
          using our API.
          <br />
          No need to register in developer programs, get your app approved, or
          do any additional steps at all. It all works out of the box.
        </p>
      </Hgroup>

      <div className={classes.block__border}>
        <ResponsiveImg img={Hiw_2} imgMobile={Hiw_2_Mobile} />
      </div>

      <Hgroup className={classes.hgroup}>
        <h2>
          3. Implement common integration scenarios as Universal Integrations
        </h2>
        <p>
          When you have the same integration scenario across multiple external
          apps, you only need to implement them once instead of implementing
          them for each app individually. <br />
          We call this Universal Integrations.
        </p>
      </Hgroup>

      <div className={clsx(classes.block__border, classes.block_3)}>
        <ResponsiveImg img={Hiw_3} imgMobile={Hiw_3_Mobile} />
      </div>

      <Hgroup className={classes.hgroup}>
        <h2>
          4. Automatically apply universal integrations to every relevant app
        </h2>
        <p>
          Integration.app will intelligently map APIs and UIs across multiple
          applications to app-specific data models and API calls. We handle all
          the commonalities and discrepancies, enabling you to interact with
          multiple apps in a consistent manner.
        </p>
      </Hgroup>
      <div className={classes.block__border}>
        <ResponsiveImg img={Hiw_4} imgMobile={Hiw_4_Mobile} />
      </div>

      <Hgroup className={classes.hgroup}>
        <h2>5. Build application-specific integration scenarios</h2>
        <p>
          When integration scenario uniquely applies to a single application,
          you can either customize an automatically-generated integration or
          build a new one from scratch, just for that single application. You
          will have access to application-specific operations, data fields, and
          even custom API requests if you want to go that deep.
        </p>
      </Hgroup>

      <div className={classes.block_5}>
        <ResponsiveImg img={Hiw_5_1} imgMobile={Hiw_5_1_Mobile} />
        <ResponsiveImg img={Hiw_5_2} imgMobile={Hiw_5_2_Mobile} />
      </div>

      <Hgroup className={classes.hgroup}>
        <h2>6. Let your users customize integrations</h2>
        <p>
          Decide what you want your customers to configure for their individual
          setups, then use our drop-in UI components or build your own fully
          custom front-end using our SDK and API.
        </p>
      </Hgroup>
      <div className={clsx(classes.block_6, classes.block__border)}>
        <div>
          <h3>Utilize our Pre-built Customization UI</h3>
          <p>
            We provide pre-built UI for customizing data sources, field
            mappings, flows, and every other aspect of the integration logic.
          </p>
          <ResponsiveImg img={Hiw_6_1} imgMobile={Hiw_6_1_Mobile} />
        </div>
        <div>
          <h3>Build Your Own with our SDK and API</h3>
          <p>
            Our REST API and Javascript SDK let you build fully white-label UI
            and make it look exactly like you and your customers need. You can
            mix and match it with pre-built UI to achieve the perfect tradeoff
            between speed and customization.
          </p>
          <ResponsiveImg img={Hiw_6_2} imgMobile={Hiw_6_2_Mobile} />
        </div>
      </div>
    </InnerPageLayout>
  )
}
